import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';

import { SparkLineChart } from '@mui/x-charts/SparkLineChart';

function getDaysInMonth(month, year) {
  const date = new Date(year, month, 0);
  const monthName = date.toLocaleDateString('en-US', {
    month: 'short',
  });
  const daysInMonth = date.getDate();
  const days = [];
  let i = 1;
  while (days.length < daysInMonth) {
    days.push(`${monthName} ${i}`);
    i += 1;
  }
  return days;
}

function renderSparklineCell(params) {
  const data = getDaysInMonth(4, 2024);
  const { value, colDef } = params;

  if (!value || value.length === 0) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <SparkLineChart
        data={value}
        width={colDef.computedWidth || 100}
        height={32}
        plotType="bar"
        showHighlight
        showTooltip
        colors={['hsl(210, 98%, 42%)']}
        xAxis={{
          scaleType: 'band',
          data,
        }}
      />
    </div>
  );
}

function renderStatus(status) {
  const colors = {
    Online: 'success',
    Offline: 'default',
  };

  return <Chip label={status} color={colors[status]} size="small" />;
}

export function renderAvatar(params) {
  if (params.value == null) {
    return '';
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: '24px',
        height: '24px',
        fontSize: '0.85rem',
      }}>
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}

export const columns = [
  { field: 'id', headerName: 'ID', flex: 0.4, minWidth: 40 },
  { field: 'nombre', headerName: 'Nombre', flex: 1, minWidth: 100 },
  { field: 'template', headerName: 'Template', flex: 1.2, minWidth: 200 },
  { field: 'fecha', headerName: 'Fecha', flex: 0.6, minWidth: 40 },
  {
    field: 'sentMessages',
    headerName: 'Enviados',
    headerAlign: 'right',
    align: 'right',
    flex: 0.2,
    minWidth: 80,
  },
  {
    field: 'readMessages',
    headerName: 'Leidos',
    headerAlign: 'right',
    align: 'right',
    flex: 0.2,
    minWidth: 100,
  },
  {
    field: 'recievedResponses',
    headerName: 'Respuestas',
    headerAlign: 'right',
    align: 'right',
    flex: 0.2,
    minWidth: 120,
  },
  {
    field: 'errors',
    headerName: 'Errores',
    headerAlign: 'right',
    align: 'right',
    flex: 0.2,
    minWidth: 100,
  },
];


/*
  {
    field: 'dailyResponses',
    headerName: 'Respuestas diarias',
    flex: 0.7,
    minWidth: 150,
    renderCell: renderSparklineCell,
  },
*/